import { differenceInDays } from 'date-fns';

import DataTable from "react-data-table-component";
import TableLoader from "./TableLoader";

import { EyeIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';

const LabourerLicenseTable = ({ licenses, licenseCount, isLoading, perPage, onPageChange, onPerPageChange, onUpdateClicked, onDeleteClicked }) => {
  const handleViewLicense = (license) => {
    window.open(license.file, '_blank');
  }

  const columns = [
    {
      name: "HRWL",
      selector: (row) => row?.type?.hrwlCode
    },
    {
      name: "Expires in",
      selector: (row) => {
        const expirationDate = new Date(row.expirationDate);
        const today = new Date();

        return `${differenceInDays(expirationDate, today)} days`;
      },
    },
    {
      right: "true",
      cell: row => (
        <div className='flex items-center gap-2'>
          <button
            onClick={e => handleViewLicense(row)}
            className='py-1 px-2 text-xs font-semibold cursor-pointer rounded-md bg-ase-blue text-white'
          >
            <EyeIcon className='md:hidden text-white h-3 w-3' />
            <span className='hidden md:block'>View</span>
          </button>

          <button
            onClick={e => onUpdateClicked(row)}
            className='py-1 px-2 text-xs font-semibold cursor-pointer rounded-md bg-ase-blue text-white'
          >
            <PencilSquareIcon className='md:hidden text-white h-3 w-3' />
            <span className='hidden md:block'>Update</span>
          </button>

          <button
            onClick={e => onDeleteClicked(row)}
            className='py-1 px-2 text-xs font-semibold cursor-pointer rounded-md bg-red-600 text-white'
          >
            <TrashIcon className='md:hidden text-white h-3 w-3' />
            <span className='hidden md:block'>Delete</span>
          </button>
        </div>
      )
    }
  ];

  return (
    <DataTable
      columns={columns}
      data={licenses}
      highlightOnHover
      striped
      pagination
      paginationServer
      progressPending={isLoading}
      progressComponent={<TableLoader />}
      paginationTotalRows={licenseCount}
      paginationRowsPerPageOptions={[5, 10, 20]}
      paginationPerPage={perPage}
      onChangePage={onPageChange}
      onChangeRowsPerPage={onPerPageChange}
    />
  )
}

export default LabourerLicenseTable;